import { FC } from 'react';

import { GiftSellerTabbedPage } from '../components/GiftSellerTabbedPage';
import { GiftCouponHistorySearchPage } from './GiftCouponHistorySearchPage';
import { GiftOrderSearchPage } from './GiftOrderSearchPage';

/**
 * 검색 — 쿠폰 내역 검색 + 주문검색을 한 메뉴로 (검색 축만 다름).
 * 구 경로 /coupon-history, /order-search 는 라우터에서 탭으로 넘긴다.
 */
export const GiftSearchPage: FC = function GiftSearchPage() {
  return (
    <GiftSellerTabbedPage
      tabs={[
        {
          key: 'coupon',
          label: '쿠폰 내역 검색',
          element: <GiftCouponHistorySearchPage />,
        },
        { key: 'order', label: '주문검색', element: <GiftOrderSearchPage /> },
      ]}
    />
  );
};
